module.exports = __webpack_public_path__ + "static/media/file-create.b063e47e.png";